import { combineReducers } from 'redux';
import { Map } from 'immutable';
import data from './data/reducer';
import core from './core';

const GROUPID_INITIAL_STATE = new Map({
    groupId: null,
    assigneeIds: null
});

function gitlabApi(state = GROUPID_INITIAL_STATE, action) {
    switch (action.type) {
        case 'SIMULATIONENR_GIT__SET_GROUPID':
            return core.setGroupId(state, action.groupId);
        case 'SIMULATIONENR_GIT__SET_ASSIGNEEIDS':
            return core.setAssigneeIds(state, action.assigneeIds);
    }
    return state;
}

export default combineReducers({
    gitlabApi,
    data
});



// WEBPACK FOOTER //
// ./environments/simulationenr/reducer.js